import type { LineTrackingCourier } from '@/infrastructure/FulfillmentAdminClient';

/** Where Edit line starts on a line's inbound parcels (SSD-7814). */
export interface OpeningParcel {
  /** The parcel already chosen, as the Edit button beside it would choose it. */
  targetId?: string;
  /** The row opens ready for a new waybill, as "+ Add waybill" would open it. */
  adding?: boolean;
  /** The chosen parcel's waybill cells, which the draft and its base both start from. Absent keeps the row's own. */
  fields?: { lineTrackingNumber: string; lineDeliveryCompany: string };
}

/**
 * Most lines have no parcel or one, so the Tracking number box is open the moment Edit line is: a line with none
 * opens ready for a new waybill, and a line with one opens on that parcel with its number and company filled in.
 * Two or more still wait for the operator to pick one, and a detail read without parcels (an older server) opens as
 * it did before. The company of a line with no parcel stays the one it shows (the pre-waybill choice), so the
 * company that a new waybill is saved with is the one on screen beside it.
 */
export const openingParcelOf = (parcels: LineTrackingCourier[] | undefined): OpeningParcel => {
  if (!Array.isArray(parcels) || parcels.length > 1) {
    return {};
  }
  const [only] = parcels;
  if (only === undefined) {
    return { adding: true };
  }
  return {
    targetId: only.trackingId,
    fields: { lineTrackingNumber: only.number, lineDeliveryCompany: only.carrier ?? '' },
  };
};
